export const defaultDateFormat = "YYYY-MM-DD";
export const defaultTimeFormat = "HH:mm";
